import React,{ useEffect, useState } from 'react';
import styles from './Dashboard.module.css';
import { useSelector, useDispatch } from "react-redux";
import { fetchDipStocks, selectDipStocks } from "../dip/DipSlice";
import { fetchTrendtocks, selectTrendStocks } from "../trend/TrendSlice";
import { selectUserWatchlist, selectIndices } from "../watchlist/WatchlistSlice";
import TrendCard from '../trend/TrendCard';

import Card from '../../components/grid/Card';
import InsightsCard2 from './InsightsCard2';

const Insights = () => {
    const dispatch = useDispatch();
    const dip_stocks = useSelector(selectDipStocks);
    const trend_stocks = useSelector(selectTrendStocks);

    const sampleData = dip_stocks ? dip_stocks: [];

    useEffect(() => {
        const dipReq = {
          months: 3,
          threshold: 5,
          indexUId: 'c3723f1c-7f99-4181-8616-4baa68300cf9'
        };
        const trendReq = {
            indexUId: 'c3723f1c-7f99-4181-8616-4baa68300cf9'
          };
        
        dispatch(fetchDipStocks(dipReq));
        dispatch(fetchTrendtocks(trendReq));
      }, []);

    
      const dipInsights = sampleData.slice(0, 2)
      const trendInsights = trend_stocks.slice(0, 2)


  return (
    <div className='container-fluid'>
      <div className={`col-lg-12 col-md-12 col-sm-12 ${styles.insights_wrapper}`}>
        <div className={styles.dashboard_title}>
          <h4>Insights</h4>
        </div>

        <div className={styles.insights_tile_wrapper}>
          <div className='row'>
          {dipInsights.map((item, index) => (
            <Card key={index} data={item} />
          ))}
            {trendInsights.map((item, index) => {
                  return (
                    (
                      <TrendCard
                        key={index}
                        item={item}
                        trendType='D'
                      />
                    )
                  );
                })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights; 